import type { FC } from 'react';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import UnauthorizedMessage from './UnauthorizedMessage';
import { EmployeeContext } from './EmployeeProvider';
import { linkDataConst } from '../navigation/NavigationMenu';

const RouteBlocker: FC = ({ children }) => {
  const EmployeeInformation = useContext(EmployeeContext);
  const location = useLocation();

  const routesWithRequiredDepartments = linkDataConst.flatMap((section) => section.linkData).filter((link) => link.requiredDepartment || link.requiredRole || Array.isArray(link.requiredJobFunction));
  const currentRoute = routesWithRequiredDepartments.find((route) => route.link === location.pathname || location.pathname.substring(0, location.pathname.lastIndexOf('/')) === route.link);

  if (currentRoute
    && (EmployeeInformation.employeeInfo?.filter((e) => (e?.department === currentRoute?.requiredDepartment || e?.role === 'Executive')).length === 0
    && EmployeeInformation.employeeInfo?.filter((e) => (e?.role === currentRoute?.requiredRole || e?.role === 'Executive')).length === 0
    && EmployeeInformation.employeeInfo?.filter((e) => (
      (currentRoute?.requiredJobFunction && currentRoute?.requiredJobFunction?.findIndex((jf) => jf === e.jobFunction) !== -1) || e?.role === 'Executive')).length === 0
    )
  ) {
    return <UnauthorizedMessage />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default RouteBlocker;
